import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import ReduxThunk from "redux-thunk";

import estimate from "./estimate";
import settings from "./settings";
import done from "./done";

const reducers = combineReducers({
  estimate,
  done,
  settings,
});

const middleware = [
  applyMiddleware(ReduxThunk),
  ...(window.__REDUX_DEVTOOLS_EXTENSION__
    ? [window.__REDUX_DEVTOOLS_EXTENSION__()]
    : []),
];

const configureStore = () => {
  const store = createStore(reducers, {}, compose(...middleware));

  if (process.env.NODE_ENV !== "production") {
    if (module.hot) {
      module.hot.accept(() => {
        store.replaceReducer(reducers);
      });
    }
  }

  return store;
};

export default configureStore;
